import React, {useState} from "react";
import Alpine from "alpinejs";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";

export function HeaderMobileMenuAccount({ settings })
{
    const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
    const linksStyle = 'h4';
    const [isAccountMenuOpen, setIsAccountMenuOpen] = useState(false);

    const handleAccountClick = () => {
        setIsAccountMenuOpen(!isAccountMenuOpen);
    };

    const useDropdownAccountMenu = false;
    let customerInitials = "A";

    if (settings.globals?.is_customer_logged_in) {
        customerInitials = settings.globals.customer_name.trim()[0];
    }

    // Filter blocks to find the one with type 'account_popup'
    const accountPopupSettings = settings.blocks.find(
        (block) => block.type === "account_popup",
    );

    return (
        <>
            {!settings.globals?.is_customer_logged_in && (
                <li className="mobile-menu-item">
                    <a href={"/account/login"} className={"h4"}>
                        LOGIN
                    </a>
                </li>
            )}

            <li className="mobile-menu-item">
                <a href={`${settings.globals?.is_customer_logged_in ? `/account/register` : `/account`}`} className={"h4"}>
                    ACCOUNT
                </a>
            </li>

            {useDropdownAccountMenu && settings.globals?.is_customer_logged_in && (
                <>
                    <div
                        className={`border border-black ${isAccountMenuOpen ? "rounded-[16px]" : "rounded-[40px]"} py-1 pl-2 pr-4 flex flex-col items-center justify-between cursor-pointer h-auto`}
                        onClick={handleAccountClick}
                    >
                        <div className="flex w-full justify-between items-center">
                            <div className="flex items-center gap-[8px]">
                                <div className="account-default-popup account-icon antialiased no-underline cursor-pointer">
                                    <div className="flex items-center justify-center text-[16px] bg-[#99FF99] rounded-full text-black font-semibold bf w-[30px] h-[30px] uppercase">
                                        <span>{customerInitials}</span>
                                    </div>
                                </div>
                                <div className="flex flex-col h5">
                                    {isAccountMenuOpen ? "Your Account" : "My Account"}
                                </div>
                            </div>

                            <i
                                className={`icon ${isAccountMenuOpen ? "icon-caret-up-thin" : "icon-caret-down-thin"}`}
                            />
                        </div>

                        {isAccountMenuOpen && (
                            <ul className="account-dropdown-menu mx-[40px] w-full py-[18px] flex gap-y-[16px] flex-col">
                                {accountPopupSettings &&
                                    accountPopupSettings?.links?.map((link, index) => (
                                        <li key={index} className="mobile-menu-sub-item">
                                            <a href={`${link.url}`} className="h4">
                                                {link.title}
                                            </a>
                                        </li>
                                    ))}

                                <li className="mobile-menu-sub-item">
                                    <a href="/account/logout" className="h5 flex items-center">
                                        <span className="underline">Log Out</span>
                                        <span className="ml-1 icon-curved-arrow-up-right text-[17px]"></span>
                                    </a>
                                </li>
                            </ul>
                        )}
                    </div>
                </>
            )}
        </>
    );
}
